// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Wd9m","right":"Footer_right__3L_Jk","buttons":"Footer_buttons__ipXOg"};